document.addEventListener("DOMContentLoaded",cnf_sgs_midorfull(), false);

document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].addEventListener("click", () => {sgs_next();});
document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_prv")[0].addEventListener("click", () => {sgs_prev();});

function sgs_next(){
  document.querySelectorAll(".sgsb_mid_title")[0].setAttribute("data-sbdisp","false");
  document.querySelectorAll(".sgs_btm_btn_error")[0].setAttribute("data-sb_errdisp","false");
  document.querySelectorAll(".sgs_btm_btn_noprd")[0].setAttribute("data-sb_errdisp","false");
  document.querySelectorAll(".sgs_btm_btn_no_next")[0].setAttribute("data-sb_errdisp","false");
  var laststep = document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].getAttribute("data-laststep");
  if(laststep == "false"){
    var LA_L = ["sgs_prd_ppn","sgs_prd_set","sgs_prd_la_siz","sgs_prd_la_clr","sgs_prd_lf_reslt"];
    var FM_L = ["sgs_prd_ppn","sgs_prd_cdn","sgs_prd_ice","sgs_prd_spa","sgs_prd_fm_siz","sgs_prd_fm_clr","sgs_prd_lf_reslt"];
    var sgslf = document.querySelectorAll(".sgs_prd_section-row[data-disp='true'] .sgs_prd_sr_ttl")[0].getAttribute("data-sgslf");
    if(sgslf == "LF"){
      rstrdo();
      var sgs_slct = document.querySelectorAll(".sgs_prd_section-row[data-disp='true'] .sgs_prd_sr_inp")[0].value;
      if(sgs_slct == 1 ){var Root_LIst = LA_L;}else{var Root_LIst = FM_L;};
    }else{
      if(sgslf == "LA"){var Root_LIst = LA_L;}else if(sgslf == "FM"){var Root_LIst = FM_L;};
    };
    var prs_row = document.querySelectorAll(".sgs_prd_section-row[data-disp='true']")[0].getAttribute("id");
    var n = Root_LIst.indexOf(prs_row);
    var go_next = false;
    
    var select_value_type = document.getElementById(prs_row).querySelectorAll(".sgs_prd_sr_field")[0].getAttribute("class");
    var go_set_collec = document.getElementById("sgs_prd_set_2").checked;
    if(select_value_type.indexOf("sgs_prd_sr_field sgs_slct") > -1 ){
      if(document.getElementById(prs_row).querySelectorAll(".sgs_prd_sr_inp")[0].value != ""){var go_next = true;};
    }else if(select_value_type.indexOf("sgs_prd_sr_field sgs_chkb") > -1){
      if(document.getElementById(prs_row).querySelectorAll(".sgs_prd_sr_chk:checked").length > 0){var go_next = true;};
    };
    if(go_next == true){var prd_exist = chk_slct_inp();}else{var prd_exist = false};
    if(go_next == true && go_set_collec == false && prd_exist == true){
      if(prs_row == "sgs_prd_set" || prs_row == "sgs_prd_spa"){
        var sizeL_base = {"1":["100-200","150-290","200-350"],"2":["200-300","300-400","350-450"],"3":["300-400","350-450","400-500"],"4":["350-450","400-500","450-550"],"5":["400-500","450-550","500-600"],"6":["450-550","500-600","600-10000"]};
        var prd_nn = document.getElementById("sgs_prd_ppn").querySelectorAll(".sgs_prd_sr_inp")[0].value;
        var siz_typ_list = sizeL_base[prd_nn];
        for(var b = 0;b < siz_typ_list.length;b++){
          if(siz_typ_list[b].split("-")[1] != "10000"){var siz_typ_A = siz_typ_list[b].split("-")[0] + "L～";var siz_typ_B = siz_typ_list[b].split("-")[1] + "L"}else{var siz_typ_A = siz_typ_list[b].split("-")[0] + "L～";var siz_typ_B = ""};
          var siz_txt = document.getElementById(Root_LIst[n + 1]).querySelectorAll('.sgs_prd_sr_lbl:has(.sgs_prd_sr_chk[data-siz_typ="' + b + '"]) .sgs_prd_srchk_dscr')[0].getAttribute("data-basest") + "（目安" + siz_typ_A + siz_typ_B + "）";
          document.getElementById(Root_LIst[n + 1]).querySelectorAll('.sgs_prd_sr_lbl:has(.sgs_prd_sr_chk[data-siz_typ="' + b + '"]) .sgs_prd_srchk_dscr')[0].textContent = siz_txt;
        };
      };
      if(prs_row == "sgs_prd_la_siz" || prs_row == "sgs_prd_fm_siz"){
        if(prs_row == "sgs_prd_la_siz"){var color_opt_list = clr_set("LA");}else if(prs_row == "sgs_prd_fm_siz"){var color_opt_list = clr_set("FM");};
        for(var c = 0;c < color_opt_list.length;c++){
          var clr = color_opt_list[c];
          var opt = document.createElement("option");
          opt.setAttribute("value",clr);
          opt.textContent = clr;
          document.getElementById(Root_LIst[n + 1]).querySelectorAll(".sgs_prd_sr_inp")[0].appendChild(opt);
        };
      };
      mid_filter("next");
      document.getElementById(Root_LIst[n]).setAttribute("data-disp","false");
      document.getElementById(Root_LIst[n + 1]).setAttribute("data-disp","true");
      document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_prv")[0].setAttribute("data-sbdisp","true");
      document.querySelectorAll(".sgs_prd_sr_snchk")[0].setAttribute("data-snchk_display","true");
      document.querySelectorAll(".sgs_prd_sr_snchk .sgs_prd_sr_snchk_ttl")[0].textContent = (n + 1) + "/" + (Root_LIst.length - 2);
      document.querySelectorAll(".sgs_prd_sr_snchk .sgs_prd_sr_snchk_inner")[0].setAttribute("data-snchk_inner",(n + 1) + "/" + (Root_LIst.length - 2));
      if(n + 3 == Root_LIst.length){
        document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].setAttribute("data-laststep","true");
      }else{
        document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].setAttribute("data-laststep","false");
      };
      document.querySelectorAll(".sgs_prd_body")[0].scrollIntoView({ behavior: "smooth" });
    }else if(go_next == true && go_set_collec == true){
      window.location.href = "/collections/%E5%AE%B6%E9%9B%BB%E3%82%BB%E3%83%83%E3%83%88";
    }else if(go_next == true && prd_exist == false){
      document.querySelectorAll(".sgs_btm_btn_no_next")[0].setAttribute("data-sb_errdisp","true");
      document.querySelectorAll(".sgs_prd_result-main .sgs_prd_result_loading_cnt")[0].setAttribute("data-sgs_dlo","false");
    }else{
      document.querySelectorAll(".sgs_btm_btn_error")[0].setAttribute("data-sb_errdisp","true");
    };
  }else if(laststep == "true"){
    var sgslf = document.querySelectorAll(".sgs_prd_section-row[data-disp='true'] .sgs_prd_sr_ttl")[0].getAttribute("data-sgslf");
    var color_slct = document.querySelectorAll(".sgs_prd_section-row:has(.sgs_prd_sr_ttl[data-sgslf='" + sgslf + "']) .sgs_prd_sr_inp")[0].value;
    if(color_slct != ""){
      document.querySelectorAll(".sgs_prd_section-row[data-disp='true']")[0].setAttribute("data-disp","false");
      document.getElementById("sgs_prd_lf_reslt").setAttribute("data-disp","true");
      document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].setAttribute("data-laststep","start");
      document.getElementById("sgs_prd_lf_reslt").querySelectorAll(".sgs_prd_sr_ttl")[0].setAttribute("data-sgslf",sgslf);
      sgs_prd_rsldisp();
      document.querySelectorAll(".sgs_prd_body")[0].scrollIntoView({ behavior: "smooth" });
    }else{
      document.querySelectorAll(".sgs_btm_btn_error")[0].setAttribute("data-sb_errdisp","true");
    };
  }else if(laststep == "start"){
    window.location.href = "/collections/sgs_prd_ref";
  };
};



function sgs_prev(){
  document.querySelectorAll(".sgsb_mid_title")[0].setAttribute("data-sbdisp","false");
  document.querySelectorAll(".sgs_btm_btn_error")[0].setAttribute("data-sb_errdisp","false");
  document.querySelectorAll(".sgs_btm_btn_noprd")[0].setAttribute("data-sb_errdisp","false");
  document.querySelectorAll(".sgs_btm_btn_no_next")[0].setAttribute("data-sb_errdisp","false");
  document.querySelectorAll(".sgs_prd_result-main .sgs_prd_result_loading_cnt")[0].setAttribute("data-sgs_dlo","false");
  var LA_L = ["sgs_prd_ppn","sgs_prd_set","sgs_prd_la_siz","sgs_prd_la_clr","sgs_prd_lf_reslt"];
  var FM_L = ["sgs_prd_ppn","sgs_prd_cdn","sgs_prd_ice","sgs_prd_spa","sgs_prd_fm_siz","sgs_prd_fm_clr","sgs_prd_lf_reslt"];
  var sgslf = document.querySelectorAll(".sgs_prd_section-row[data-disp='true'] .sgs_prd_sr_ttl")[0].getAttribute("data-sgslf");
  if(sgslf == "LF"){
    rstrdo();
    var sgs_slct = document.querySelectorAll(".sgs_prd_section-row[data-disp='true'] .sgs_prd_sr_inp")[0].value;
    if(sgs_slct == 1 ){var Root_LIst = LA_L;}else{var Root_LIst = FM_L;};
  }else{
    rst_slct_frmprs();
    if(sgslf == "LA"){var Root_LIst = LA_L;}else if(sgslf == "FM"){var Root_LIst = FM_L;};
  };
  var prs_row = document.querySelectorAll(".sgs_prd_section-row[data-disp='true']")[0].getAttribute("id");
  var n = Root_LIst.indexOf(prs_row);
  document.getElementById(Root_LIst[n]).setAttribute("data-disp","false");
  document.getElementById(Root_LIst[n - 1]).setAttribute("data-disp","true");
  if(document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].getAttribute("data-laststep") == "start"){
    document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].setAttribute("data-sbdisp","true");
    document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].setAttribute("data-laststep","true");
  }else{
    document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].setAttribute("data-sbdisp","true");
    document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].setAttribute("data-laststep","false");
  };  
  if(n - 1 == 0){
    document.querySelectorAll(".sgs_prd_sr_snchk")[0].setAttribute("data-snchk_display","false");
    document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_prv")[0].setAttribute("data-sbdisp","false");
  }else{
    document.querySelectorAll(".sgs_prd_sr_snchk")[0].setAttribute("data-snchk_display","true");
    document.querySelectorAll(".sgs_prd_sr_snchk .sgs_prd_sr_snchk_ttl")[0].textContent = (n - 1) + "/" + (Root_LIst.length - 2);
    document.querySelectorAll(".sgs_prd_sr_snchk .sgs_prd_sr_snchk_inner")[0].setAttribute("data-snchk_inner",(n - 1) + "/" + (Root_LIst.length - 2));
    document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_prv")[0].setAttribute("data-sbdisp","true");
  };
  mid_filter("prev");
  document.querySelectorAll(".sgs_prd_body")[0].scrollIntoView({ behavior: "smooth", block: "start" });
};



function clr_set(FL){
  var prd_nn = parseInt(document.querySelectorAll(".sgs_prd_main .sgs_prd_sr_inp")[0].value);
  var sizeL_base = {"1":["100-200","150-290","200-350"],"2":["200-300","300-400","350-450"],"3":["300-400","350-450","400-500"],"4":["350-450","400-500","450-550"],"5":["400-500","450-550","500-600"],"6":["450-550","500-600","600-10000"]};
  var siz_type = parseInt(document.querySelectorAll(".sgs_prd_section-row:has(.sgs_prd_sr_ttl[data-sgslf='" + FL + "']) .sgs_prd_sr_chk[data-siz_typ]:checked")[0].getAttribute("data-siz_typ"));
  var sizeL = sizeL_base[prd_nn][siz_type];

  var FM_L = document.querySelectorAll(".sgs_prd_section-row:has(.sgs_prd_sr_ttl[data-sgslf='" + FL + "']) .sgs_prd_sr_chk[data-set_rdo]");
  var slct_L = [];
  for(var a = 0;a < FM_L.length;a++){
    var inp_data = FM_L[a].getAttribute("data-set_rdo");
    if(FM_L[a].checked && inp_data !== ""){
      slct_L.push(inp_data);
    };
  };
  var prd_list = JSON.parse(document.querySelectorAll(".sgs_prd_rsl_pl")[0].getAttribute("data-rsl_pl"));
  var sz_str = parseInt(sizeL.split("-")[0]);
  var sz_fin = parseInt(sizeL.split("-")[1]);
  var prd_dt_A = prd_list.filter(prd => prd.size >= sz_str && prd.size <= sz_fin);
  if(slct_L.length > 0){
    var prd_dt_A_flted = prd_dt_A.filter(prd => slct_L.every(tag => prd.spc.includes(tag)));
  }else{
    var prd_dt_A_flted = prd_dt_A;
  }
  var prd_dt_A_sorted = prd_dt_A_flted.sort((a, b) => a.size - b.size);

  var clr_opt_list = [];
  rstclr();
  for(var b = 0;b < prd_dt_A_sorted.length;b++){
    for(var c = 0;c < prd_dt_A_sorted[b].clr.length;c++){
      if(clr_opt_list.indexOf(prd_dt_A_sorted[b].clr[c]) == -1){
        clr_opt_list.push(prd_dt_A_sorted[b].clr[c]);
      };
    };
  };
  return clr_opt_list;
};



function sgs_prd_rsldisp(){
  var prd_nn = parseInt(document.querySelectorAll(".sgs_prd_main .sgs_prd_sr_inp")[0].value);
  if(prd_nn > 1){var FL = "FM";}else{var FL = "LA";};
  var sizeL_base = {"1":["100-200","150-290","200-350"],"2":["200-300","300-400","350-450"],"3":["300-400","350-450","400-500"],"4":["350-450","400-500","450-550"],"5":["400-500","450-550","500-600"],"6":["450-550","500-600","600-10000"]};
  var siz_type = parseInt(document.querySelectorAll(".sgs_prd_section-row:has(.sgs_prd_sr_ttl[data-sgslf='" + FL + "']) .sgs_prd_sr_chk[data-siz_typ]:checked")[0].getAttribute("data-siz_typ"));
  var sizeL = sizeL_base[prd_nn][siz_type];

  var FM_L = document.querySelectorAll(".sgs_prd_section-row:has(.sgs_prd_sr_ttl[data-sgslf='" + FL + "']) .sgs_prd_sr_chk[data-set_rdo]");
  var slct_L = [];
  for(var a = 0;a < FM_L.length;a++){
    var inp_data = FM_L[a].getAttribute("data-set_rdo");
    if(FM_L[a].checked && inp_data !== ""){
      slct_L.push(inp_data);
    };
  };
  var prd_list = JSON.parse(document.querySelectorAll(".sgs_prd_rsl_pl")[0].getAttribute("data-rsl_pl"));
  var sz_str = parseInt(sizeL.split("-")[0]);
  var sz_fin = parseInt(sizeL.split("-")[1]);
  var prd_dt_A = prd_list.filter(prd => prd.size >= sz_str && prd.size <= sz_fin);
  if(slct_L.length > 0){
    var prd_dt_A_flted = prd_dt_A.filter(prd => slct_L.every(tag => prd.spc.includes(tag)));
  }else{
    var prd_dt_A_flted = prd_dt_A;
  }
  st_elm_box_delt();
  if(prd_dt_A_flted.length > 0){
    document.querySelectorAll(".sgs_prd_result-main .sgs_prd_result_loading_cnt")[0].setAttribute("data-sgs_dlo","loading");
    var color_slct = document.querySelectorAll(".sgs_prd_section-row:has(.sgs_prd_sr_ttl[data-sgslf='" + FL + "']) .sgs_prd_sr_inp")[0].value;
    if(color_slct !== "" && color_slct !== "none"){
      var color_data = [];
      color_data.push(color_slct);
      var prd_dt_B_flted = prd_dt_A_flted.filter(prd => color_data.every(tag => prd.clr.includes(tag)));
    }else{
      var prd_dt_B_flted = prd_dt_A_flted;
    };
    var prd_dt_B_sorted = prd_dt_B_flted.sort((a, b) => a.size - b.size);
    st_elm_box(prd_dt_B_sorted,slct_L,color_slct,sizeL,prd_nn);
  }else{
    document.querySelectorAll(".sgs_btm_btn_noprd")[0].setAttribute("data-sb_errdisp","true");
    document.querySelectorAll(".sgs_prd_result-main .sgs_prd_result_loading_cnt")[0].setAttribute("data-sgs_dlo","false");
  };
};



function st_elm_box(srt_data,slc_spc,c_slct,szrng,pr_pn){
  var spcul = "/collections/srt_ref_cllc/" + slc_spc.join("+") + "?rf_szrng=" + szrng + "_*_" + pr_pn;
  if(c_slct !== "" && c_slct !== "none"){
    var crldata = JSON.parse(document.querySelectorAll(".sgs_prd_rsl_pl")[0].getAttribute("data-clr_fltl"));
    var spcul = spcul + "_*_" + c_slct + "&filter.v.option.カラー=" + crldata[c_slct].join(",");
  };
  for(var a = 1;a < 4;a++){
    var setdt = false;    
    if(a == 1 && srt_data.length >= a){
      if(srt_data.length > 2){
        var slc_dt = gtmdl_prdlist(srt_data);
        var setdt = true;
      }else{
        var slc_dt = srt_data[0];
        var setdt = true;
      };
    }else if(a == 2 && srt_data.length >= a){
      var slc_dt = srt_data[srt_data.length - 1];
      var setdt = true;
    }else if(a == 3 && srt_data.length >= a){
      var slc_dt = srt_data[0];
      var setdt = true;
    };
    if(setdt == true){
      var st_elem = document.querySelectorAll(".sgs_prd_result_box[data-sgsp_rb='rb_" + a + "']")[0];
      st_elem.querySelectorAll(".sgs_prd_rb_img img")[0].setAttribute("data-sgsimg_ld","loading");
      var FL = document.querySelectorAll(".sgs_prd_section-row[data-disp='true'] .sgs_prd_sr_ttl")[0].getAttribute("data-sgslf");
      var color_slct = document.querySelectorAll(".sgs_prd_section-row:has(.sgs_prd_sr_ttl[data-sgslf='" + FL + "']) .sgs_prd_sr_inp")[0].value;
      if(color_slct != "" && color_slct != "none"){
        var c = slc_dt.clr.indexOf(color_slct);
        var vrnt_param = "?variant=" + slc_dt.clr_varnt[c];
        var prd_img = slc_dt.clr_img[c];
      }else{
        var vrnt_param = "";
        var prd_img = slc_dt.img;
      };
      st_elem.querySelectorAll(".sgs_prd_rb_img img")[0].setAttribute("src","//pandaselections.com/cdn/shop/" + prd_img);
      if(st_elem.querySelectorAll(".sgs_prd_rb_img img")[0].complete){
        st_elem.querySelectorAll(".sgs_prd_rb_img img")[0].setAttribute("data-sgsimg_ld","loaded");
      }else{
        st_elem.querySelectorAll(".sgs_prd_rb_img img")[0].addEventListener('load', () => {st_elem.querySelectorAll(".sgs_prd_rb_img img")[0].setAttribute("data-sgsimg_ld","loaded");img_chkslf();});
      };
      st_elem.querySelectorAll(".sgs_prd_rb_prc")[0].textContent = "¥" + parseInt(slc_dt.prc).toLocaleString();
      st_elem.querySelectorAll(".sgs_prd_rb_ttl")[0].textContent = slc_dt.ttl.split("<br>")[0] + "\n" + slc_dt.ttl.split("<br>")[1];
      st_elem.querySelectorAll(".sgs_prd_rb_mkr")[0].textContent = slc_dt.mkr;
      
      st_elem.querySelectorAll(".sgs_prd_rb_btm_btn.sprb_U")[0].setAttribute("href","/products/" + slc_dt.hndl + vrnt_param);
      
      if(srt_data.length > 3){
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].setAttribute("style","");
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].setAttribute("href",spcul);
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].textContent = "すべての検索結果を表示（" + srt_data.length + "件）";
      }else{
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].setAttribute("style","display:none;");
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].setAttribute("href","");
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].textContent = "";
      };
    };
  };
  img_chkslf();
};



function st_elm_box_delt(){
  for(var a = 1;a < 4;a++){
    var st_elem = document.querySelectorAll(".sgs_prd_result_box[data-sgsp_rb='rb_" + a + "']")[0];
    st_elem.querySelectorAll(".sgs_prd_rb_img img")[0].setAttribute("data-sgsimg_ld","false");
    st_elem.querySelectorAll(".sgs_prd_rb_img img")[0].setAttribute("src","");
    st_elem.querySelectorAll(".sgs_prd_rb_prc")[0].textContent = "";
    st_elem.querySelectorAll(".sgs_prd_rb_ttl")[0].textContent = "";
    st_elem.querySelectorAll(".sgs_prd_rb_mkr")[0].textContent = "";
  };
};



function rstrdo(){
  var chk_elem = document.querySelectorAll(".sgs_prd_main .sgs_prd_sr_chk");
  for(var a = 0;a < chk_elem.length;a++){
    chk_elem[a].checked = false;
  };
};



function rstclr(){
  var optL = document.getElementById("sgs_prd_la_clr").querySelectorAll("option");
  for(var a = 0;a < optL.length;a++){
    if(optL[a].value !== "" && optL[a].value !== "none"){
      optL[a].remove();
    };
  };
  var optL = document.getElementById("sgs_prd_fm_clr").querySelectorAll("option");
  for(var a = 0;a < optL.length;a++){
    if(optL[a].value !== "" && optL[a].value !== "none"){
      optL[a].remove();
    };
  };
};


function img_chkslf(){
  var st_elem = document.querySelectorAll(".sgs_prd_result-main .sgs_prd_result_box img");
  var set_disp = true;
  for(var a = 0;a < st_elem.length;a++){
    if(st_elem[a].complete && st_elem[a].getAttribute("src") != ""){
      st_elem[a].setAttribute("data-sgsimg_ld","loaded");
    }else if(st_elem[a].complete && st_elem[a].getAttribute("src") == ""){
      st_elem[a].setAttribute("data-sgsimg_ld","false");
    }else{
      var chk_load = st_elem[a].getAttribute("data-sgsimg_ld");
      if(chk_load == "loading"){
        var set_disp = false;
      };
    };
  };
  if(set_disp == true){
    document.querySelectorAll(".sgs_prd_result-main .sgs_prd_result_loading_cnt")[0].setAttribute("data-sgs_dlo","loaded");
  };
};


function gtmdl_prdlist(bs_lstdt_sgs){
  var md_sz = Math.abs((parseInt(bs_lstdt_sgs[0].size) + parseInt(bs_lstdt_sgs[bs_lstdt_sgs.length - 1].size)) / 2);
  var md_data = bs_lstdt_sgs.reduce((prev, curr) => {return Math.abs(curr.size - md_sz) < Math.abs(prev.size - md_sz) ? curr : prev;}, bs_lstdt_sgs[0]);
  return md_data;
};


function cnf_sgs_pd(){
  var CRTurl = new URL(window.location.href);
  var crt_size_base = CRTurl.searchParams.get("sgs_pdd");
  if(crt_size_base != null){
    var sizeL_base = {"1":["100-200","150-290","200-350"],"2":["200-300","300-400","350-450"],"3":["300-400","350-450","400-500"],"4":["350-450","400-500","450-550"],"5":["400-500","450-550","500-600"],"6":["450-550","500-600","600-10000"]};
    var pd = crt_size_base.split("_,_");
    var prd_p = pd[0];
    if(prd_p == "1"){var FL = "LA";}else{var FL = "FM";};
    var prd_tgs = pd[1].split("_*_");
    var all_rdo = document.querySelectorAll(".sgs_prd_section-row:has(.sgs_prd_sr_ttl[data-sgslf='" + FL + "']) .sgs_prd_sr_chk[data-set_rdo='']");
    for(var a = 0;a < all_rdo.length;a++){all_rdo[a].checked = true;};
    for(var a = 0;a < prd_tgs.length;a++){
      if(prd_tgs[a] != ""){
        document.querySelectorAll(".sgs_prd_section-row:has(.sgs_prd_sr_ttl[data-sgslf='" + FL + "'])  .sgs_prd_sr_chk[data-set_rdo='" + prd_tgs[a] + "']")[0].checked = true;
      };
    };
    document.querySelectorAll(".sgs_prd_main .sgs_prd_sr_inp")[0].value = prd_p;
    var prd_siz = sizeL_base[prd_p].indexOf(pd[2]);
    document.querySelectorAll(".sgs_prd_section-row:has(.sgs_prd_sr_ttl[data-sgslf='" + FL + "'])  .sgs_prd_sr_chk[data-siz_typ='" + prd_siz + "']")[0].checked = true;
    var siz_typ_list = sizeL_base[prd_p];
    for(var b = 0;b < siz_typ_list.length;b++){
      if(siz_typ_list[b].split("-")[1] != "10000"){var siz_typ_A = siz_typ_list[b].split("-")[0] + "L～";var siz_typ_B = siz_typ_list[b].split("-")[1] + "L"}else{var siz_typ_A = siz_typ_list[b].split("-")[0] + "L～";var siz_typ_B = ""};
      var siz_type_ed = "sgs_prd_" + FL.toLowerCase() + "_siz";
      var siz_txt = document.getElementById(siz_type_ed).querySelectorAll('.sgs_prd_sr_lbl:has(.sgs_prd_sr_chk[data-siz_typ="' + b + '"]) .sgs_prd_srchk_dscr')[0].getAttribute("data-basest") + "（目安" + siz_typ_A + siz_typ_B + "）";
      document.getElementById(siz_type_ed).querySelectorAll('.sgs_prd_sr_lbl:has(.sgs_prd_sr_chk[data-siz_typ="' + b + '"]) .sgs_prd_srchk_dscr')[0].textContent = siz_txt;
    };
    
    if(prd_p == "1"){var color_opt_list = clr_set("LA");}else{var color_opt_list = clr_set("FM");};
    var cid = "sgs_prd_" + FL.toLowerCase() + "_clr";
    for(var c = 0;c < color_opt_list.length;c++){
      var clr = color_opt_list[c];
      var opt = document.createElement("option");
      opt.setAttribute("value",clr);
      opt.textContent = clr;
      document.getElementById(cid).querySelectorAll(".sgs_prd_sr_inp")[0].appendChild(opt);
    };
    if(pd.length > 3){
      document.getElementById(cid).querySelectorAll(".sgs_prd_sr_inp")[0].value = pd[3];
    }else{
      document.getElementById(cid).querySelectorAll(".sgs_prd_sr_inp")[0].value = "none";
    };
    
    document.getElementById("sgs_prd_ppn").setAttribute("data-disp","false");
    document.getElementById(cid).setAttribute("data-disp","true");
    document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].setAttribute("data-laststep","true");
    document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_prv")[0].setAttribute("data-sbdisp","true");
    var sgslf = document.querySelectorAll(".sgs_prd_section-row[data-disp='true'] .sgs_prd_sr_ttl")[0].getAttribute("data-sgslf");
    document.querySelectorAll(".sgs_prd_section-row[data-disp='true']")[0].setAttribute("data-disp","false");
    document.getElementById("sgs_prd_lf_reslt").setAttribute("data-disp","true");
    document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].setAttribute("data-laststep","start");
    document.getElementById("sgs_prd_lf_reslt").querySelectorAll(".sgs_prd_sr_ttl")[0].setAttribute("data-sgslf",sgslf);
    document.querySelectorAll(".sgs_prd_result-main .sgs_prd_result_loading_cnt")[0].setAttribute("data-sgs_dlo","loading");
    sgs_prd_rsldisp();
  };
};


function chk_slct_inp(){
  var prs_row = document.querySelectorAll(".sgs_prd_section-row[data-disp='true']")[0].getAttribute("id");
  var prd_nn = parseInt(document.querySelectorAll(".sgs_prd_main .sgs_prd_sr_inp")[0].value);
  if(prd_nn > 1){var FL = "FM";}else{var FL = "LA";};
  var FM_L = document.querySelectorAll(".sgs_prd_section-row:has(.sgs_prd_sr_ttl[data-sgslf='" + FL + "']) .sgs_prd_sr_chk[data-set_rdo]");
  var slct_L = [];
  for(var a = 0;a < FM_L.length;a++){
    var inp_data = FM_L[a].getAttribute("data-set_rdo");
    if(FM_L[a].checked && inp_data !== ""){
      slct_L.push(inp_data);
    };
  };
  var prd_list = JSON.parse(document.querySelectorAll(".sgs_prd_rsl_pl")[0].getAttribute("data-rsl_pl"));
  if(prs_row == "sgs_prd_la_siz" || prs_row == "sgs_prd_fm_siz"){
    var sizeL_base = {"1":["100-200","150-290","200-350"],"2":["200-300","300-400","350-450"],"3":["300-400","350-450","400-500"],"4":["350-450","400-500","450-550"],"5":["400-500","450-550","500-600"],"6":["450-550","500-600","600-10000"]};
    var siz_type = parseInt(document.querySelectorAll(".sgs_prd_section-row:has(.sgs_prd_sr_ttl[data-sgslf='" + FL + "']) .sgs_prd_sr_chk[data-siz_typ]:checked")[0].getAttribute("data-siz_typ"));
    var sizeL = sizeL_base[prd_nn][siz_type];
  }else{
    var sizeL_base = {"1":"100-350","2":"200-450","3":"300-500","4":"350-550","5":"400-600","6":"450-10000"};
    var sizeL = sizeL_base[prd_nn];
  };
  var sz_str = parseInt(sizeL.split("-")[0]);
  var sz_fin = parseInt(sizeL.split("-")[1]);
  var prd_dt_A = prd_list.filter(prd => prd.size >= sz_str && prd.size <= sz_fin);
  if(slct_L.length > 0){
    var prd_dt_A_flted = prd_dt_A.filter(prd => slct_L.every(tag => prd.spc.includes(tag)));
  }else{
    var prd_dt_A_flted = prd_dt_A;
  };
  if(prd_dt_A_flted.length == 0){
    var g_nxt = false;
  }else{
    document.querySelectorAll(".sgs_btm_btn_no_next")[0].setAttribute("data-sb_errdisp","false");
    document.querySelectorAll(".sgs_prd_result-main .sgs_prd_result_loading_cnt")[0].setAttribute("data-sgs_dlo","false");
    var g_nxt = true;
  };
  return g_nxt;
};


function rst_slct_frmprs(){
  var prs_row = document.querySelectorAll(".sgs_prd_section-row[data-disp='true']")[0].getAttribute("id");
  var prd_nn = document.getElementById("sgs_prd_ppn").querySelectorAll(".sgs_prd_sr_inp")[0].value;
  if(prd_nn > 1){
    var FL = "FM";
    var Root_LIst = ["sgs_prd_ppn","sgs_prd_cdn","sgs_prd_ice","sgs_prd_spa","sgs_prd_fm_siz","sgs_prd_fm_clr"];
  }else{
    var FL = "LA";
    var Root_LIst = ["sgs_prd_ppn","sgs_prd_set","sgs_prd_la_siz","sgs_prd_la_clr"];
  };
  var aft_cnt = Root_LIst.slice(Root_LIst.indexOf(prs_row));
  for(var a = 0;a < aft_cnt.length;a++){
    if(document.getElementById(aft_cnt[a]).querySelectorAll("select")[0]){
      document.getElementById(aft_cnt[a]).querySelectorAll("select")[0].value = "";
    }else if(document.getElementById(aft_cnt[a]).querySelectorAll("input")[0]){
      var aft_inp = document.getElementById(aft_cnt[a]).querySelectorAll("input");
      for(var b = 0;b < aft_inp.length;b++){
        aft_inp[b].checked = false;
      };
    };
  };
};


function mid_filter(np_cnf){
  document.querySelectorAll(".sgs_prd_result-main .sgs_prd_result_loading_cnt")[0].setAttribute("data-sgs_dlo","false");
  document.getElementById("sgs_prd_lf_reslt").setAttribute("data-disp","false");
  var prs_row = document.querySelectorAll(".sgs_prd_section-row[data-disp='true']")[0].getAttribute("id");
  var prd_nn = parseInt(document.querySelectorAll(".sgs_prd_main .sgs_prd_sr_inp")[0].value);
  if(prd_nn > 1){
    var FL = "FM";
    var Root_LIst = ["sgs_prd_ppn","sgs_prd_cdn","sgs_prd_ice","sgs_prd_spa","sgs_prd_fm_siz","sgs_prd_fm_clr"];
  }else{
    var FL = "LA";
    var Root_LIst = ["sgs_prd_ppn","sgs_prd_set","sgs_prd_la_siz","sgs_prd_la_clr"];
  };
  var FM_L = document.querySelectorAll(".sgs_prd_section-row:has(.sgs_prd_sr_ttl[data-sgslf='" + FL + "']) .sgs_prd_sr_chk[data-set_rdo]");
  var slct_L = [];
  for(var a = 0;a < FM_L.length;a++){
    var inp_data = FM_L[a].getAttribute("data-set_rdo");
    if(FM_L[a].checked && inp_data !== ""){
      slct_L.push(inp_data);
    };
  };
  var prd_list = JSON.parse(document.querySelectorAll(".sgs_prd_rsl_pl")[0].getAttribute("data-rsl_pl"));
  if(prs_row == "sgs_prd_la_siz" || prs_row == "sgs_prd_fm_siz"){
    var sizeL_base = {"1":["100-200","150-290","200-350"],"2":["200-300","300-400","350-450"],"3":["300-400","350-450","400-500"],"4":["350-450","400-500","450-550"],"5":["400-500","450-550","500-600"],"6":["450-550","500-600","600-10000"]};
    var siz_type = parseInt(document.querySelectorAll(".sgs_prd_section-row:has(.sgs_prd_sr_ttl[data-sgslf='" + FL + "']) .sgs_prd_sr_chk[data-siz_typ]:checked")[0].getAttribute("data-siz_typ"));
    var sizeL = sizeL_base[prd_nn][siz_type];
  }else{
    var sizeL_base = {"1":"100-350","2":"200-450","3":"300-500","4":"350-550","5":"400-600","6":"450-10000"};
    var sizeL = sizeL_base[prd_nn];
  };
  var sz_str = parseInt(sizeL.split("-")[0]);
  var sz_fin = parseInt(sizeL.split("-")[1]);
  var prd_dt_A = prd_list.filter(prd => prd.size >= sz_str && prd.size <= sz_fin);
  if(slct_L.length > 0){
    var prd_dt_A_flted = prd_dt_A.filter(prd => slct_L.every(tag => prd.spc.includes(tag)));
  }else{
    var prd_dt_A_flted = prd_dt_A;
  };
  st_elm_box_delt();
  if(prd_dt_A_flted.length > 0){
    if(np_cnf == "next" || prs_row != "sgs_prd_ppn"){
      document.querySelectorAll(".sgs_prd_result-main .sgs_prd_result_loading_cnt")[0].setAttribute("data-sgs_dlo","loading");
      document.querySelectorAll(".sgsb_mid_title")[0].setAttribute("data-sbdisp","true");
      var prd_dt_A_sorted = prd_dt_A_flted.sort((a, b) => a.size - b.size);
      mid_st_elm_box(prd_dt_A_sorted,slct_L,"none",sizeL,prd_nn);
    };
  }else{
    document.querySelectorAll(".sgs_btm_btn_noprd")[0].setAttribute("data-sb_errdisp","true");
    document.querySelectorAll(".sgs_prd_result-main .sgs_prd_result_loading_cnt")[0].setAttribute("data-sgs_dlo","false");
  };
  document.querySelectorAll(".sgs_prd_body")[0].scrollIntoView({ behavior: "smooth" });
};

function mid_st_elm_box(srt_data,slc_spc,c_slct,szrng,pr_pn){
  var prs_row = document.querySelectorAll(".sgs_prd_section-row[data-disp='true']")[0].getAttribute("id");
  if(pr_pn > 1){var Root_LIst = ["sgs_prd_ppn","sgs_prd_cdn","sgs_prd_ice","sgs_prd_spa","sgs_prd_fm_siz","sgs_prd_fm_clr"];}else{var Root_LIst = ["sgs_prd_ppn","sgs_prd_set","sgs_prd_la_siz","sgs_prd_la_clr"];};
  var next_row = Root_LIst[parseInt(Root_LIst.indexOf(prs_row)) + 1];
  var spu_lst = [];
  for(var a = 0;a < Root_LIst.length;a++){
    var vl_ind_chkd = document.getElementById(Root_LIst[a]).querySelectorAll(".sgs_prd_sr_chk:checked")[0];
    var vl_ind_list = document.getElementById(Root_LIst[a]).querySelectorAll(".sgs_prd_sr_chk");
    var vl_ind = Array.from(vl_ind_list).indexOf(vl_ind_chkd);
    spu_lst.push(Root_LIst[a] + "~" + vl_ind);
    if(Root_LIst[a] == next_row){break};
  };
  var spcul = "/collections/srt_ref_cllc/" + slc_spc.join("+") + "?mid_rf_szrng=" + szrng + "_" + pr_pn + "_;" + spu_lst.join(";");
  for(var a = 1;a < 4;a++){
    var setdt = false;    
    if(a == 1 && srt_data.length >= a){
      if(srt_data.length > 2){
        var slc_dt = gtmdl_prdlist(srt_data);
        var setdt = true;
      }else{
        var slc_dt = srt_data[0];
        var setdt = true;
      };
    }else if(a == 2 && srt_data.length >= a){
      var slc_dt = srt_data[srt_data.length - 1];
      var setdt = true;
    }else if(a == 3 && srt_data.length >= a){
      var slc_dt = srt_data[0];
      var setdt = true;
    };
    if(setdt == true){
      var st_elem = document.querySelectorAll(".sgs_prd_result_box[data-sgsp_rb='rb_" + a + "']")[0];
      st_elem.querySelectorAll(".sgs_prd_rb_img img")[0].setAttribute("data-sgsimg_ld","loading");
      var FL = document.querySelectorAll(".sgs_prd_section-row[data-disp='true'] .sgs_prd_sr_ttl")[0].getAttribute("data-sgslf");
      var vrnt_param = "";
      var prd_img = slc_dt.img;
      st_elem.querySelectorAll(".sgs_prd_rb_img img")[0].setAttribute("src","//pandaselections.com/cdn/shop/" + prd_img);
      if(st_elem.querySelectorAll(".sgs_prd_rb_img img")[0].complete){
        st_elem.querySelectorAll(".sgs_prd_rb_img img")[0].setAttribute("data-sgsimg_ld","loaded");
      }else{
        st_elem.querySelectorAll(".sgs_prd_rb_img img")[0].addEventListener('load', () => {st_elem.querySelectorAll(".sgs_prd_rb_img img")[0].setAttribute("data-sgsimg_ld","loaded");img_chkslf();});
      };
      st_elem.querySelectorAll(".sgs_prd_rb_prc")[0].textContent = "¥" + parseInt(slc_dt.prc).toLocaleString();
      st_elem.querySelectorAll(".sgs_prd_rb_ttl")[0].textContent = slc_dt.ttl;
      /*st_elem.querySelectorAll(".sgs_prd_rb_ttl")[0].textContent = slc_dt.ttl.split("<br>")[0] + "\n" + slc_dt.ttl.split("<br>")[1];*/
      st_elem.querySelectorAll(".sgs_prd_rb_mkr")[0].textContent = slc_dt.mkr;
      
      st_elem.querySelectorAll(".sgs_prd_rb_btm_btn.sprb_U")[0].setAttribute("href","/products/" + slc_dt.hndl + vrnt_param);
      
      if(srt_data.length > 3){
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].setAttribute("style","");
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].setAttribute("href",spcul);
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].textContent = "すべての候補を表示（" + srt_data.length + "件）";
      }else{
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].setAttribute("style","display:none;");
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].setAttribute("href","");
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].textContent = "";
      };
    };
  };
  img_chkslf();
};


function cnf_sgs_pd_mid(){
  var CRTurl = new URL(window.location.href);
  var crt_size_base = CRTurl.searchParams.get("sgs_pdd_mid");
  if(crt_size_base != null){
    var spl_base = crt_size_base.split("_;")[0].split("-;");
    var pr_pn = spl_base[0];
    document.getElementById("sgs_prd_ppn").querySelectorAll("select")[0].value = pr_pn;
    if(pr_pn > 1){var Root_LIst = ["sgs_prd_ppn","sgs_prd_cdn","sgs_prd_ice","sgs_prd_spa","sgs_prd_fm_siz","sgs_prd_fm_clr"];}else{var Root_LIst = ["sgs_prd_ppn","sgs_prd_set","sgs_prd_la_siz","sgs_prd_la_clr"];};
    var elem_list = crt_size_base.split("_;")[1].split(";");
    for(var a=0;a < elem_list.length;a++){
      var elmd = elem_list[a].split("~")[0];
      var elmv = elem_list[a].split("~")[1];
      if(elem_list[a] != ""){
        if(elmv > -1){
          document.getElementById(elmd).querySelectorAll(".sgs_prd_sr_chk")[elmv].checked = true;
        };
      };
    };
    if(elmd != "sgs_prd_ppn"){
      document.getElementById("sgs_prd_ppn").setAttribute("data-disp","false");
      var prs_row = Root_LIst[parseInt(Root_LIst.indexOf(elmd)) - 1];
      document.getElementById(prs_row).setAttribute("data-disp","true");
      sgs_next();
    };
  };
};

function cnf_sgs_midorfull() {
  var CRTurl = new URL(window.location.href);
  var crt_size_base = CRTurl.searchParams.get("sgs_pdd");
  var crt_size_base_mid = CRTurl.searchParams.get("sgs_pdd_mid");
  if(crt_size_base != null){
    cnf_sgs_pd();
  };
  if(crt_size_base_mid != null){
    cnf_sgs_pd_mid();
  };
};